import React from "react";
import { Button, Result } from "antd";
import { Link } from "react-router-dom";

const Unauthorized = () => {
  return (
    <Result
      status="403"
      title="403"
      subTitle={`Tu plan actual no permite acceder a esta página. `}
      extra={
        <>
          <Link to="/">
            <Button ghost type="primary">
              Regresar
            </Button>
          </Link>
          <Link to="/memberships/pricing">
            <Button type="primary">Mejorar Plan</Button>
          </Link>
        </>
      }
    />
  );
};

export default Unauthorized;
